import Vue from 'vue'
import { jumpToLogin } from '@/mixins/auth'

const initialOptions = {
    method: 'get',
}

const errorFormate = (error) => {
    const {
        url = '',
        body = {},
        status = ''
    } = error || {}
    Vue.sendSentry && Vue.sendSentry(`${status}, ${JSON.stringify(body)}`, {url});
}

const request = (options = initialOptions) => {
    return new Promise((resolve, reject) => {
        Vue.http({
            ...options
        }).then((res) => {
            resolve(res)
        }, (err) => {
            if (err.status === 401) {
                jumpToLogin()
            } else {
                errorFormate(err)
                reject(err)
            }
        })
    })
}

export default request
